/* ============================================================
   EFFIE KATS — THEME JS
   ============================================================ */

/* ── GLOBAL WISHLIST ── */
window.EKWishlist = (function () {
  var KEY = 'ek_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }

  function saveList(list) { localStorage.setItem(KEY, JSON.stringify(list)); }

  function toggle(btn) {
    var handle = btn.dataset.handle;
    var list = getList();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        handle: handle,
        title: btn.dataset.title || '',
        price: btn.dataset.price || '',
        image: btn.dataset.image || '',
        url: btn.dataset.url || ('/products/' + handle)
      });
    }
    saveList(list);
    syncHearts();
  }

  function syncHearts() {
    var handles = getList().map(function (i) { return i.handle; });
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      btn.classList.toggle('active', handles.indexOf(btn.dataset.handle) > -1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { syncHearts(); });

  return { toggle: toggle, syncHearts: syncHearts, getList: getList };
})();

document.addEventListener('DOMContentLoaded', function () {

  /* ── 1. TRANSPARENT NAV ON HOMEPAGE ── */
  var nav = document.querySelector('nav.ek-nav');
  var isHome = document.body.classList.contains('home-page');
  if (nav && isHome) {
    nav.classList.add('ek-nav--transparent');
    window.addEventListener('scroll', function () {
      if (window.scrollY > 36) {
        nav.classList.remove('ek-nav--transparent');
        nav.classList.add('scrolled');
      } else {
        nav.classList.add('ek-nav--transparent');
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ── 2. MEGA MENU (desktop hover) ── */
  var triggers = document.querySelectorAll('.ek-mega-trigger');
  var backdrop = document.getElementById('ekMegaBackdrop');
  var openMega = null;
  var closeTimer = null;

  function showMega(handle) {
    clearTimeout(closeTimer);
    if (openMega && openMega !== handle) hideMega(openMega, true);
    var panel = document.getElementById('ek-mega-' + handle);
    var trigger = document.querySelector('.ek-mega-trigger[data-menu="' + handle + '"]');
    if (panel) { panel.classList.add('open'); }
    if (trigger) { trigger.classList.add('active'); }
    if (backdrop) { backdrop.classList.add('open'); }
    openMega = handle;
  }

  function hideMega(handle, immediate) {
    var panel = document.getElementById('ek-mega-' + handle);
    var trigger = document.querySelector('.ek-mega-trigger[data-menu="' + handle + '"]');
    if (immediate) {
      if (panel) panel.classList.remove('open');
      if (trigger) trigger.classList.remove('active');
      if (backdrop) backdrop.classList.remove('open');
      openMega = null;
    } else {
      closeTimer = setTimeout(function () {
        if (panel) panel.classList.remove('open');
        if (trigger) trigger.classList.remove('active');
        if (backdrop) backdrop.classList.remove('open');
        openMega = null;
      }, 150);
    }
  }

  triggers.forEach(function (trigger) {
    var handle = trigger.getAttribute('data-menu');
    trigger.addEventListener('mouseenter', function () { showMega(handle); });
    trigger.addEventListener('mouseleave', function () { hideMega(handle, false); });
    // Touch toggle
    trigger.addEventListener('click', function () {
      if (openMega === handle) { hideMega(handle, true); } else { showMega(handle); }
    });
  });

  document.querySelectorAll('.ek-mega').forEach(function (panel) {
    var handle = panel.getAttribute('data-menu');
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { hideMega(handle, false); });
  });

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      if (openMega) hideMega(openMega, true);
    });
  }

  /* ── 6. CART COUNT UPDATE ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ek-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      }).catch(function () {});
  }
  updateCartCount();

  /* ── 7. CART PAGE — qty + remove ── */
  document.addEventListener('click', function (e) {
    // Qty buttons
    if (e.target.classList.contains('ek-qty-btn')) {
      var control = e.target.closest('.ek-qty-control');
      if (!control) return;
      var key = control.getAttribute('data-line-key');
      var valEl = control.querySelector('.ek-qty-val');
      var current = parseInt(valEl ? valEl.textContent : '1') || 1;
      var isPlus = e.target.getAttribute('data-action') === 'plus';
      var newQty = isPlus ? current + 1 : Math.max(0, current - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function () { location.reload(); }).catch(function () {});
    }

    // Remove buttons
    if (e.target.classList.contains('ek-cart-remove')) {
      var key = e.target.getAttribute('data-line-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { location.reload(); }).catch(function () {});
    }
  });

  /* ── 8. NAV SCROLL SHRINK ── */
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 36);
    }, { passive: true });
  }

  /* ── 9. STICKY NAV ── */
  (function () {
    var headerWrap = document.querySelector('.ek-header-wrap');
    var mainContent = document.getElementById('main-content');
    if (!headerWrap) return;

    var ANNOUNCE_H = 36;
    var NAV_H = 60;
    var isSticky = false;

    function applySticky() {
      if (isSticky) return;
      isSticky = true;
      headerWrap.style.position = 'fixed';
      headerWrap.style.top = '0';
      headerWrap.style.left = '0';
      headerWrap.style.width = '100%';
      headerWrap.style.background = 'white';
      headerWrap.style.zIndex = '200';
      if (!isHome && mainContent) mainContent.style.paddingTop = NAV_H + 'px';
    }

    function removeSticky() {
      if (!isSticky) return;
      isSticky = false;
      headerWrap.style.position = '';
      headerWrap.style.top = '';
      headerWrap.style.left = '';
      headerWrap.style.width = '';
      headerWrap.style.background = '';
      headerWrap.style.zIndex = '';
      if (!isHome && mainContent) mainContent.style.paddingTop = '';
    }

    function onScroll() {
      if (window.scrollY >= ANNOUNCE_H) {
        applySticky();
      } else {
        removeSticky();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

});
